export default "__VITE_ASSET__DrZX282s__"